import { render, staticRenderFns } from "./ColorBalls.vue?vue&type=template&id=2be4e718&scoped=true"
import script from "./ColorBalls.vue?vue&type=script&lang=js"
export * from "./ColorBalls.vue?vue&type=script&lang=js"
import style0 from "./ColorBalls.vue?vue&type=style&index=0&id=2be4e718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4e718",
  null
  
)

export default component.exports